Ext.ns('mx.comp');

mx.comp.ButtonColumn = function(config) {
    Ext.apply(this, config);
    if (!this.id) {
        this.id = Ext.id();
    }
    this.renderer = this.renderer.createDelegate(this);
};

mx.comp.ButtonColumn.prototype = {
    init: function(grid) {
        this.grid = grid;
        this.grid.on(
            'render',
            function() {
                var view = this.grid.getView();
                view.mainBody.on('mousedown', this.onMouseDown, this);
            },
            this
        );
    },

    onMouseDown: function(e, t) {
        if (t.className && t.className.indexOf('grid-button-' + this.id) != -1) {
            e.stopEvent();
            var index = this.grid.getView().findRowIndex(t);
            var record = this.grid.store.getAt(index);
            record.set(this.dataIndex, !record.data[this.dataIndex]);
            if (this.handler) {
                this.handler.call(this, record.data[this.dataIndex], record);
            }
        }
    },

    renderer: function(v, p, record) {
        return '<input type="button" class="grid-button-' + this.id + '" value="' + this.text + '" />';
    },
};
